import { render, staticRenderFns } from "./flightDetails.vue?vue&type=template&id=1e4ee016&scoped=true"
import script from "./flightDetails.vue?vue&type=script&lang=js"
export * from "./flightDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4ee016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4ee016')) {
      api.createRecord('1e4ee016', component.options)
    } else {
      api.reload('1e4ee016', component.options)
    }
    module.hot.accept("./flightDetails.vue?vue&type=template&id=1e4ee016&scoped=true", function () {
      api.rerender('1e4ee016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/booking/flightDetails.vue"
export default component.exports